module.exports = __webpack_public_path__ + "img/om.9459d415.png";